import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {

  const [showSuccess, setShowSuccess] = React.useState(false)

  React.useEffect(() => {
    // ============================================
    // SMOOTH SCROLL ENHANCEMENT
    // ============================================
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    });

    // Smooth scroll animation on scroll
    let lastScrollY = window.scrollY;
    let ticking = false;

    const smoothScroll = () => {
      lastScrollY = window.scrollY;
      ticking = false;
    };

    const requestTick = () => {
      if (!ticking) {
        window.requestAnimationFrame(smoothScroll);
        ticking = true;
      }
    };

    window.addEventListener('scroll', requestTick, { passive: true });

    // ============================================
    // FADE-IN ON SCROLL ANIMATIONS
    // ============================================
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    // Observe all sections except hero
    document.querySelectorAll('section:not(.hero-section)').forEach(section => {
      observer.observe(section);
    });

    // ============================================
    // CLEANUP
    // ============================================
    return () => {
      window.removeEventListener('scroll', requestTick);
      observer.disconnect();
    };
  }, []);


  // Check for success parameter on component mount
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('submitted') === 'true') {
      setShowSuccess(true)
      // Clear the URL parameter
      window.history.replaceState({}, '', window.location.pathname)
    }
  }, [])

  // Add mobile video handling
  React.useEffect(() => {
    const handleMobileVideo = () => {
      const video = document.querySelector('.hero-video-background video');
      if (video && window.innerWidth <= 768) {
        // On mobile, ensure video plays with proper attributes
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
        video.muted = true;
        video.play().catch(err => {
          console.log('Video autoplay failed:', err);
          // Fallback: show poster or background image
          video.style.display = 'none';
        });
      }
    };
    
    handleMobileVideo();
    window.addEventListener('resize', handleMobileVideo);
    
    return () => window.removeEventListener('resize', handleMobileVideo);
  }, []);
return (
    <div className="home-container1">
      <Helmet>
        <title>Nature Ready Exports</title>
        <meta property="og:title" content="Nature Ready Exports" />
      </Helmet>
      <Navigation></Navigation>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
        @keyframes fadeInUp {from {opacity: 0;
transform: translateY(30px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: var(--font-family-body);
  line-height: 1.6;
  color: var(--color-on-surface);
  background-color: var(--color-surface);
}
@media (prefers-reduced-motion: reduce) {
*, *::before, *::after {
  animation-duration: 0.01ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.01ms !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="home-container6">
        <div className="home-container7">
          <Script
            html={`<script defer data-name="homepage-interactions">
(function(){
  // Smooth animations on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate-fade-up")
      }
    })
  }, observerOptions)

  // Observe sections for animations
  const sections = document.querySelectorAll("section")
  sections.forEach((section) => observer.observe(section))

  // Hero parallax effect
  const heroVideo = document.querySelector(".hero-video-background video")
  const heroOverlay = document.querySelector(".hero-overlay")

  window.addEventListener("scroll", () => {
    const scrolled = window.pageYOffset
    const rate = scrolled * -0.5

    if (heroVideo) {
      heroVideo.style.transform = \`translateY(\${rate}px)\`
    }

    if (heroOverlay) {
      const opacity = Math.min(scrolled / 300, 0.8)
      heroOverlay.style.background = \`linear-gradient(135deg, 
      rgba(250, 249, 247, \${0.8 + opacity * 0.2}), 
      rgba(237, 231, 221, \${0.6 + opacity * 0.3}))\`
    }
  })

  // Inquiry form interactions
  const inquiryToggle = document.querySelector(".inquiry-toggle")
  const inquiryForm = document.getElementById("inquiryForm")

  if (inquiryToggle) {
    inquiryToggle.addEventListener("click", () => {
      const formContainer = document.querySelector(".inquiry-form-container")
      if (formContainer) {
        formContainer.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      }
    })
  }

  // Form submission handling
  // Form submission handling
if (inquiryForm) {
  // Check if form was just submitted (redirected back with success parameter)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('submitted') === 'true') {
    const submitBtn = inquiryForm.querySelector('button[type="submit"]');
    if (submitBtn) {
      const originalText = submitBtn.textContent;
      submitBtn.textContent = "Inquiry Sent Successfully!";
      submitBtn.style.background = "#16a34a";
      submitBtn.disabled = true;
      
      // Clear the URL parameter and reset button after 5 seconds
      setTimeout(() => {
        window.history.replaceState({}, '', window.location.pathname);
        submitBtn.textContent = originalText;
        submitBtn.style.background = "";
        submitBtn.disabled = false;
        inquiryForm.reset();
      }, 5000);
    }
  }

  // Mobile video autoplay fix for iOS
  if (window.innerWidth <= 768) {
    const video = document.querySelector('.hero-video-background video');
    if (video) {
      // iOS requires user interaction, so we try to play on any touch
      document.addEventListener('touchstart', function playVideo() {
        video.play().catch(() => {});
        document.removeEventListener('touchstart', playVideo);
      }, { once: true });
    }
  }
  
  // Form validation before submission
  inquiryForm.addEventListener("submit", (e) => {
    const requiredFields = inquiryForm.querySelectorAll("[required]");
    let isValid = true;

    requiredFields.forEach((field) => {
      if (!field.value.trim()) {
        field.style.borderBottomColor = "#dc2626";
        isValid = false;
      } else {
        field.style.borderBottomColor = "#16a34a";
      }
    });

    if (!isValid) {
      e.preventDefault(); // Prevent submission if validation fails
      
      // Show error message
      const submitBtn = inquiryForm.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = "Please fill all required fields";
      submitBtn.style.background = "#dc2626";
      
      setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.style.background = "";
      }, 2000);
    }
    // If valid, form submits normally to FormSubmit
  });

  // Clear field error styling on input
  inquiryForm.querySelectorAll('input, textarea').forEach(field => {
    field.addEventListener('input', () => {
      if (field.hasAttribute('required')) {
        field.style.borderBottomColor = field.value.trim() ? "#16a34a" : "";
      }
    });
  });
}

  // Product card hover effects
  const productCards = document.querySelectorAll(".product-card")
  productCards.forEach((card) => {
    card.addEventListener("mouseenter", () => {
      card.style.transform = "translateY(-8px) scale(1.02)"
    })

    card.addEventListener("mouseleave", () => {
      card.style.transform = ""
    })
  })

  // Map pin interactions
  const mapPins = document.querySelectorAll(".map-pin")
  mapPins.forEach((pin) => {
    pin.addEventListener("click", () => {
      const region = pin.dataset.region

      // Simple interaction feedback
      pin.style.transform = "scale(1.2)"
      setTimeout(() => {
        pin.style.transform = ""
      }, 200)

      // You could add more complex interactions here
      console.log(\`Clicked on region: \${region}\`)
    })
  })

  // Certification card animations
  const certItems = document.querySelectorAll(".cert-item")
  certItems.forEach((item, index) => {
    item.style.animationDelay = \`\${index * 100}ms\`
  })

  // Video loading optimization
  const videos = document.querySelectorAll("video")
  videos.forEach((video) => {
    video.addEventListener("canplaythrough", () => {
      video.style.opacity = "1"
    })
  })

  // Smooth scrolling for any anchor links
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault()
      const target = document.querySelector(this.getAttribute("href"))
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
    })
  })

  // Performance optimization: Lazy load images
  // Performance optimization: Lazy load images
const images = document.querySelectorAll("img")
const imageObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const img = entry.target
      
      // Check if image is already loaded
      if (img.complete && img.naturalHeight !== 0) {
        // Image already loaded, show it immediately
        img.style.opacity = "1"
      } else {
        // Image not loaded yet, wait for load event
        img.style.opacity = "0"
        img.style.transition = "opacity 0.3s ease-in-out"
        
        img.addEventListener("load", () => {
          img.style.opacity = "1"
        })
      }

      imageObserver.unobserve(img)
    }
  })
})

images.forEach((img) => {
  // Set initial transition for all images
  img.style.transition = "opacity 0.3s ease-in-out"
  imageObserver.observe(img)
})()
</script>`}
          ></Script>
        </div>
      </div>
      <section id="hero" className="hero-section">
        <div className="hero-video-background">
          <video
            autoPlay
            muted
            loop
            playsInline
            webkit-playsinline="true"
            preload="auto"
            src={require('../images/hero_video.mp4')}
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <div className="hero-grid">
            <div className="hero-text">
              <div className="hero-badge">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10"></path>
                    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
                  </g>
                </svg>
                <span>
                  {' '}
                  Premium Export Quality
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </div>
              <h1 className="hero-title">Nature Ready</h1>
              <h2 className="hero-subtitle">Purely Prepared.</h2>
              <p className="section-content">
                {' '}
                Exquisite Indian botanicals and premium agrarian produce,
                sustainably sourced and export-ready for discerning markets
                worldwide. Handpicked. Ethically packed. Globally trusted.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="hero-cta-group">
                <a href="/inquiry-custom-order" className="btn btn-primary btn-lg">
                  Request Inquiry
                </a>
                <div className="hero-trust-signals">
                  <span>Trusted exports</span>
                  <span>Global compliance</span>
                  <span>Curated quality</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="trust-certifications" className="trust-section">
        <div className="section-container">
          <div className="trust-grid">
            <div className="trust-content">
              <h2 className="section-title">
                Trusted, traceable, exceptional.
              </h2>
              <p className="section-content">
                {' '}
                Nature Ready partners with leading export authorities and
                independent laboratories to ensure every shipment meets rigorous
                international standards.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="certifications-grid">
                <div className="cert-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    ></path>
                  </svg>
                  <h3>IEC Registered</h3>
                  <p>Authorized by DGFT for international Export</p>
                </div>
                <div className="cert-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                      <circle cx="12" cy="8" r="6"></circle>
                    </g>
                  </svg>
                  <h3>FSSAI Exporter</h3>
                  <p>Regulatory compliance</p>
                </div>
                <div className="cert-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                    ></path>
                  </svg>
                  <h3>Organic Verified</h3>
                  <p>Certified organic produce*</p>
                </div>
              </div>
            </div>
            <div className="trust-stats">
              <div className="stats-card">
                <div className="stat-item">
                  <h3>25+</h3>
                  <p>Distribution Hubs Served</p>
                </div>
                <div className="stat-item">
                  <h3>4.8/5</h3>
                  <p>Customer Rating</p>
                </div>
                <div className="stat-item">
                  <h3>96%</h3>
                  <p>On-Time Delivery</p>
                </div>
              </div>
              <div className="testimonial-card">
                <blockquote>
                  <span>
                    {' '}
                    &quot;Exceptional traceability and packaging. Our orders
                    arrive pristine, every time.&quot;
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>A. Mendes, Importer, Vietnam</span>
                </blockquote>
              </div>
              <div className="testimonial-card">
                <blockquote>
                  <span>
                    {' '}
                    &quot;Transparent documentation and attentive service made
                    onboarding seamless.&quot;
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>R. Kapoor, Distributor, UAE</span>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="product-spotlight" className="products-section">
        <div className="section-container">
          <div className="products-header">
            <h2 className="section-title">Product Spotlight</h2>
            <p className="section-subtitle">
              Curated for exporters and connoisseurs — premium quality produce, tested origins, and global-ready packaging.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>

          <div className="products-grid">

            {/* Product 1 */}
            <div className="product-card">
              <div className="product-image">
                <img
                  src={require('../images/MalyarC_Prod.png')}
                  alt="Malyar Grade C Raisins"
                />
                <div className="product-overlay">
                  <span className="product-badge">Natural</span>
                </div>
              </div>
              <div className="product-content">
                <h3>Malyar Grade C Raisins</h3>
                <p>
                  Naturally sun-dried raisins with balanced sweetness and soft texture. Ideal for baking and confectionery export.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="product-details">
                  <span>15 kg</span>
                  <span>Grade C • Natural</span>
                  <span>MOQ 1 Case</span>
                </div>
              </div>
            </div>

            {/* Product 2 */}
            <div className="product-card">
              <div className="product-image">
                <img
                  src={require('../images/MalyarAA_Prod.png')}
                  alt="Malyar AA Raisins"
                />
                <div className="product-overlay">
                  <span className="product-badge">Premium</span>
                </div>
              </div>
              <div className="product-content">
                <h3>Malyar AA Raisins</h3>
                <p>
                  Superior-grade golden raisins with uniform size and exceptional flavor profile, perfect for international retail packaging.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="product-details">
                  <span>20 kg</span>
                  <span>Premium • Sustainable</span>
                  <span>MOQ 1 Pallet</span>
                </div>
              </div>
            </div>

            {/* Product 3 */}
            <div className="product-card">
              <div className="product-image">
                <img
                  src={require('../images/Golden_Round_Prod.png')}
                  alt="Golden Round Raisins"
                />
                <div className="product-overlay">
                  <span className="product-badge">Golden Select</span>
                </div>
              </div>
              <div className="product-content">
                <h3>Golden Round Raisins</h3>
                <p>
                  Bright golden hue and rich flavor, carefully dried under controlled sunlight to retain nutrients and luster.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="product-details">
                  <span>12 kg</span>
                  <span>Golden • Natural</span>
                  <span>MOQ 2 Cases</span>
                </div>
              </div>
            </div>

            {/* Product 4 */}
            <div className="product-card">
              <div className="product-image">
                <img
                  src={require('../images/turmeric_hero.jpeg')}
                  alt="Turmeric Powder"
                />
                <div className="product-overlay">
                  <span className="product-badge">Organic</span>
                </div>
              </div>
              <div className="product-content">
                <h3>Turmeric Powder — Curcumin 3–5%</h3>
                <p>
                  Fine-ground turmeric with consistent curcumin levels. Ideal for culinary and nutraceutical export applications.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="product-details">
                  <span>25 kg</span>
                  <span>Organic • Pure</span>
                  <span>MOQ 1 Case</span>
                </div>
              </div>
            </div>

            {/* Product 5 */}
            <div className="product-card">
              <div className="product-image">
                <img
                  src={require('../images/Turmeric_Extract_Prod.jpg')}
                  alt="Turmeric Extract"
                />
                <div className="product-overlay">
                  <span className="product-badge">High Potency</span>
                </div>
              </div>
              <div className="product-content">
                <h3>Turmeric Extract — Curcumin 95%</h3>
                <p>
                  Concentrated turmeric extract, standardized to 95% curcumin. Suitable for pharmaceutical and health supplement sectors.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="product-details">
                  <span>10 kg</span>
                  <span>Premium • 95% Curcumin</span>
                  <span>MOQ 2 Cases</span>
                </div>
              </div>
            </div>

            {/* Product 6 */}
            <div className="product-card">
              <div className="product-image">
                <img
                  src={require('../images/Moringa_Prod.png')}
                  alt="Moringa Leaf Powder"
                />
                <div className="product-overlay">
                  <span className="product-badge">Superfood</span>
                </div>
              </div>
              <div className="product-content">
                <h3>Moringa Leaf Powder</h3>
                <p>
                  Nutrient-dense superfood powder made from shade-dried moringa leaves. Tested for purity and export certified.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </p>
                <div className="product-details">
                  <span>20 kg</span>
                  <span>Organic • Superfood</span>
                  <span>MOQ 1 Pallet</span>
                </div>
              </div>
            </div>

          </div>

          <div className="products-footer">
            <p>
              Transparent pricing tiers • Batch lab certificates • Flexible fulfillment • Dedicated export manager
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>
        </div>
      </section>

      <section id="inquiry-access" className="inquiry-section">
        <div className="section-container">
          <div className="inquiry-grid">
            <div className="inquiry-content">
              <h2 className="section-title">Request Inquiry</h2>
              <p className="section-content">
                {' '}
                Speak with our export specialists to source premium, certified
                goods. Fast responses, competitive MOQ, and global logistics
                support.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="inquiry-benefits">
                <div className="benefit-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                  <span>Tailored pricing and certificate copies</span>
                </div>
                <div className="benefit-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                      <circle cx="17" cy="18" r="2"></circle>
                      <circle cx="7" cy="18" r="2"></circle>
                    </g>
                  </svg>
                  <span>Comprehensive shipping options</span>
                </div>
                <div className="benefit-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    ></path>
                  </svg>
                  <span>Secure &amp; confidential handling of data</span>
                </div>
              </div>
              <button className="inquiry-toggle btn btn-primary btn-lg">
                {' '}
                Use This Quick Inquiry Form To Submit Your Order →
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </button>
            </div>
            <div className="inquiry-form-container">
              <form id="inquiryForm" className="inquiry-form" action="https://formsubmit.co/thenatureready@gmail.com" method="POST">
                {/* FormSubmit Configuration - Hidden Fields */}
                <input type="hidden" name="_subject" value="New Inquiry from Nature Ready Website" />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />
                <input type="hidden" name="_next" value={typeof window !== 'undefined' ? window.location.origin + "?submitted=true" : ""} />
                
                <div className="form-header">
                  <h3>Quick Inquiry</h3>
                  <p>Get a response within one business day</p>
                </div>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <div className="input-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </g>
                      </svg>
                      <input type="text" id="name" name="Name" required />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="company">Company / Brand</label>
                    <div className="input-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                        </g>
                      </svg>
                      <input type="text" id="company" name="Company" required />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <div className="input-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                          <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                          <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                        </g>
                      </svg>
                      <input type="email" id="email" name="Email" required />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone (With Country Code)</label>
                    <div className="input-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"></path>
                      </svg>
                      <input type="tel" id="phone" name="Phone" />
                    </div>
                  </div>
                  <div className="form-group form-group-full">
                    <label htmlFor="product">Product of Interest</label>
                    <div className="input-wrapper">
                      <input type="text" id="product" name="Product_of_Interest" placeholder="e.g., Organic Turmeric Powder" />
                    </div>
                  </div>
                  <div className="form-group form-group-full">
                    <label htmlFor="quantity">Quantity &amp; Timeline</label>
                    <div className="input-wrapper">
                      <input type="text" id="quantity" name="Quantity_and_Timeline" placeholder="e.g., 1000 kg, needed by March 2025" />
                    </div>
                  </div>
                  <div className="form-group form-group-full">
                    <label htmlFor="message">Message (optional)</label>
                    <div className="input-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"></path>
                      </svg>
                      <textarea id="message" name="Message" rows="3" placeholder="Specific requirements or questions..."></textarea>
                    </div>
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-lg">Submit Inquiry</button>
                <div className="form-footer">
                  <p>Your data is handled with industry-standard security for export contracts and commercial quotes.</p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <section id="sustainability" className="sustainability-section">
        <div className="section-container">
          <div className="sustainability-grid">
            <div className="sustainability-content">
              <h2 className="section-title">
                {' '}
                Our Commitment — Traceable, Thoughtful, Timeless
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </h2>
              <p className="section-content">
                {' '}
                Every Nature Ready product begins with a documented origin. We
                partner with certified growers and artisan cooperatives across
                India, maintaining chain-of-custody records from harvest through
                export.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="commitment-cards">
                <div className="commitment-card">
                  <div className="card-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881a1.79 1.79 0 0 1-.004-1.784L7.196 9.5M11 19h8.203a1.83 1.83 0 0 0 1.556-.89a1.78 1.78 0 0 0 0-1.775l-1.226-2.12"></path>
                          <path d="m14 16l-3 3l3 3m-5.707-8.404L7.196 9.5L3.1 10.598m6.244-4.787l1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.78 1.78 0 0 1 1.546.888l3.943 6.843"></path>
                          <path d="m13.378 9.633l4.096 1.098l1.097-4.096"></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <h3>Sustainable Materials</h3>
                  <p>
                    {' '}
                    Naturally dried raisins, sun-cured turmeric, and sustainably sourced moringa—crafted for minimal environmental impact.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="commitment-card">
                  <div className="card-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
                      ></path>
                    </svg>
                  </div>
                  <h3>Ethical Supply Chain</h3>
                  <p>
                    {' '}
                    Fair wages, safe working conditions, and long-term supplier
                    relationships with enforced labor standards and community
                    reinvestment.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="commitment-card">
                  <div className="card-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10"></path>
                        <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
                      </g>
                    </svg>
                  </div>
                  <h3>Reduced Footprint</h3>
                  <p>
                    {' '}
                    Recyclable cartons, compostable fillers, and lightweight
                    packaging strategy that minimizes shipping emissions and
                    waste.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
                <div className="commitment-card">
                  <div className="card-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                      ></path>
                    </svg>
                  </div>
                  <h3>Certifications &amp; Verification</h3>
                  <p>
                    {' '}
                    Certified organic, fair-trade, and FSSAI-compliant processes
                    with visible documentation and audit summaries.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </p>
                </div>
              </div>
              
            </div>
            <div className="sustainability-visual">
              <img
                src={require('../images/indian_farmers_harvest.jpeg')}
                alt="Indian farmers harvesting fresh leafy greens sustainably"
              />
            </div>
          </div>
        </div>
      </section>
      <section id="global-reach" className="global-section">
        <div className="section-container">
          <div className="global-header">
            <h2 className="section-title">Global Reach</h2>
            <p className="section-subtitle">
              {' '}
              From India to the world — curated exports delivered with precision
              across verified shipping corridors and certified customs hubs.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>
          <div className="global-grid">
            <div className="global-map-container">
              <div className="global-map">
                <img
                  src={require('../images/GlobalReach.png')}
                  alt="Agricultural landscape representing global reach"
                />
                <div className="map-overlays">
                  <div data-region="europe" className="map-pin pin-europe">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                      </g>
                    </svg>
                    <span>Europe</span>
                  </div>
                  <div data-region="asia" className="map-pin pin-asia">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                      </g>
                    </svg>
                    <span>East Asia</span>
                  </div>
                  <div
                    data-region="middle-east"
                    className="map-pin pin-middle-east"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                      </g>
                    </svg>
                    <span>Middle East</span>
                  </div>
                  <div data-region="america" className="map-pin pin-america">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                      </g>
                    </svg>
                    <span>North America</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="global-info">
              <div className="key-markets">
                <h3>Key Markets</h3>
                <div className="markets-grid">
                  <span>Europe</span>
                  <span>North America</span>
                  <span>Middle East</span>
                  <span>East Asia</span>
                  <span>Southeast Asia</span>
                  <span>Australia</span>
                </div>
              </div>
              <div className="global-stats">
                <h3>Performance Metrics</h3>
                <div className="stat-grid">
                  <div className="stat-item">
                    <span className="stat-number">10-21</span>
                    <span className="stat-label">Days average lead time</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">96%</span>
                    <span className="stat-label">On-time delivery rate</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">25+</span>
                    <span className="stat-label">Strategic distribution hubs served</span>
                  </div>
                </div>
              </div>
              <div className="global-features">
                <h3>Why Our Footprint Matters</h3>
                <div className="feature-list">
                  <div className="feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span>Local logistics partners in each region</span>
                  </div>
                  <div className="feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span>Temperature-controlled handling facilities</span>
                  </div>
                  <div className="feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span>Export-compliant packaging standards</span>
                  </div>
                  <div className="feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span>Audited facilities and performance records</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>

      {/* Success Popup */}
      {showSuccess && (
        <div 
          className={`success-popup ${showSuccess ? 'show' : ''}`}
          onClick={() => setShowSuccess(false)}
        >
          <div className="success-popup-content">
            <div className="success-icon-large">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 6L9 17l-5-5"></path>
              </svg>
            </div>
            <h3>Inquiry Submitted Successfully! 🎉</h3>
            <p>Thank you for your interest. Our export team will respond to your inquiry as soon as possible, typically within 24 hours.</p>
            <p className="success-subtext">A confirmation email has been sent to your inbox.</p>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                setShowSuccess(false);
              }}
              style={{
                marginTop: '1.5rem',
                padding: '0.75rem 2rem',
                background: 'rgba(255, 255, 255, 0.2)',
                border: '2px solid white',
                borderRadius: '8px',
                color: 'white',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
              onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Home
